import { FC } from 'react'

import { PerformanceFeedbackEntriesDocument } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { EmptyState } from 'modules/performance_feedbacks/components/EmptyState'
import { FeedbackEntries } from 'modules/performance_feedbacks/components/FeedbackEntries'

type Props = {
  receiverId: number
  isOpen: boolean
  onClose: () => void
}

export const FeedbackEntriesSidepanel: FC<Props> = ({ receiverId, isOpen, onClose }) => {
  const { data } = useQuery(PerformanceFeedbackEntriesDocument, {
    variables: {
      receiverId: receiverId,
    },
  })
  const feedbackEntries = data?.feedbacks.feedbackEntriesConnection.nodes
  return (
    <Sidepanel
      open={isOpen}
      onClose={onClose}
      width="wide"
      title={i18n.t('performance_process.reviews.answer_evaluation.past_feedback')}
    >
      {feedbackEntries?.length ? (
        <FeedbackEntries entries={feedbackEntries} size={12} />
      ) : (
        <EmptyState
          title={i18n.t('performance_feedbacks.empty_state.no_feedback')}
          description={i18n.t('performance_feedbacks.empty_state.title')}
          hasCTAButton={false}
        />
      )}
    </Sidepanel>
  )
}
